import { EditorContextHelper } from '@magnolia/template-annotations';

export default EditorContextHelper;
